import { getReports } from "api/aiChat";

const reportConfig = {
  getReports
};

export default reportConfig;